import { Modal } from '@plick/ui';
import ReactPlayer from 'react-player';
import { useEffect, useState } from 'react';
import { SUBSCRIPTION_TYPES_MAP } from '@utils/constants';
import { useSubscription } from '@pages/Subscriptionsv2/hooks/useSubscriptions';
import { useGetAnnouncement } from './hooks/useGetAnnouncement';

export const CommunicationsModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { planId } = useSubscription();
  const planLabel = SUBSCRIPTION_TYPES_MAP[planId]?.label || 'desconocido';
  const formattedDate = new Intl.DateTimeFormat('fr-CA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'America/Mexico_City',
  }).format(new Date());
  const { announcement } = useGetAnnouncement({
    date: formattedDate,
    plan: planLabel,
    is_active: true,
    page_size: 1,
  });

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  useEffect(() => {
    if (announcement?.uuid) {
      const { uuid, show_once } = announcement;
      const hasBeenShown = localStorage.getItem(`announcement_${uuid}`);
      if (!show_once || !hasBeenShown) {
        handleOpenModal();
        if (show_once) {
          localStorage.setItem(`announcement_${uuid}`, 'true');
        }
      }
    }
  }, [announcement]);

  return (
    <Modal
      padding="0rem"
      maxHeight="90vh"
      isOpen={isModalOpen}
      onClose={() => handleCloseModal()}
      closableWaitingTime={announcement?.delay_before_close || 0}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <div>
        <ReactPlayer url={announcement?.video_url} width="100%" height="50vh" controls />
        <div className="px-3 py-4">
          <h1 id="modal-title" className="text-3xl font-bold text-center mb-4">
            {announcement?.title}
          </h1>
          <h2 id="modal-description" className="text-xl text-gray-600 text-center mb-4">
            {announcement?.subtitle}
          </h2>
          {announcement?.long_description ? (
            <p className="mt-6 break-words text-center">{announcement?.long_description}</p>
          ) : null}
        </div>
      </div>
    </Modal>
  );
};
